(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-oferta"] && !Shopify.designMode) return;
  try {
    
  class PromoPopup extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.key;
      this.frequency = this.dataset.frequency || 'session';
      this.designMode = !!(window.Shopify && window.Shopify.designMode);

      var raw = (this.dataset.deadline || '').trim();
      var parsed = raw ? new Date(raw).getTime() : NaN;
      this.deadline = isNaN(parsed) ? null : parsed;
      this.expired = this.deadline !== null && this.deadline <= Date.now();

      this.querySelectorAll('[data-pp-close]').forEach(
        function (el) { el.addEventListener('click', this.close.bind(this)); }.bind(this)
      );
      this.onKey = function (e) { if (e.key === 'Escape') this.close(); }.bind(this);

      if (this.deadline !== null) this.tick();

      // No personalizador o popup abre sempre, para poder editar o conteudo.
      if (this.designMode) { this.open(); return; }
      if (this.expired && this.dataset.hideExpired === 'true') return;
      if (this.alreadySeen()) return;

      var delay = parseInt(this.dataset.delay, 10);
      this.timeout = setTimeout(this.open.bind(this), (isNaN(delay) ? 3 : delay) * 1000);
    }

    disconnectedCallback() {
      clearTimeout(this.timeout);
      clearInterval(this.interval);
      document.removeEventListener('keydown', this.onKey);
    }

    store(type) {
      try { return type === 'session' ? window.sessionStorage : window.localStorage; }
      catch (e) { return null; }
    }

    alreadySeen() {
      if (this.frequency === 'always') return false;
      var st = this.store(this.frequency === 'session' ? 'session' : 'local');
      if (!st) return false;
      try {
        if (this.frequency === 'session') return st.getItem(this.key) === '1';
        return st.getItem(this.key) === new Date().toDateString();
      } catch (e) { return false; }
    }

    markSeen() {
      if (this.frequency === 'always' || this.designMode) return;
      var st = this.store(this.frequency === 'session' ? 'session' : 'local');
      if (!st) return;
      try {
        st.setItem(this.key, this.frequency === 'session' ? '1' : new Date().toDateString());
      } catch (e) {}
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
      this.markSeen();
      var focusable = this.querySelector('.promo-popup__cta, .promo-popup__close');
      if (focusable) focusable.focus({ preventScroll: true });
    }

    close() {
      clearTimeout(this.timeout);
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
    }

    pad(n) { return (n < 10 ? '0' : '') + n; }

    tick() {
      var render = function () {
        var diff = Math.floor((this.deadline - Date.now()) / 1000);
        if (diff <= 0) {
          diff = 0;
          clearInterval(this.interval);
          if (this.dataset.hideExpired === 'true' && !this.designMode) this.close();
        }
        var d = Math.floor(diff / 86400);
        var set = function (attr, value) {
          var el = this.querySelector('[data-pp-' + attr + ']');
          if (el) el.textContent = this.pad(value);
        }.bind(this);
        var daysUnit = this.querySelector('[data-pp-unit-days]');
        if (daysUnit) daysUnit.hidden = d === 0;
        set('days', d);
        set('hours', Math.floor((diff % 86400) / 3600));
        set('minutes', Math.floor((diff % 3600) / 60));
        set('seconds', diff % 60);
      }.bind(this);

      render();
      this.interval = setInterval(render, 1000);
    }
  }

  if (!customElements.get('promo-popup')) customElements.define('promo-popup', PromoPopup);

  } catch(e) { console.error(e); }
})();
})();
